import { withRouter } from 'react-router-dom';
import TimelineElement from './TimelineElement';

export default withRouter(TimelineElement);
